<template>
  <SimpleModuleDashboard
    :module-id="Modules.PRODUCTOS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="dashboardActions"
    :widget-filter="filterWidgets"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import Session from '@/handler/session'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    parameters: {
      haveLines: Helper.hasParametersAccess(Param.P7),
      haveColors: Helper.hasParametersAccess(Param.P8),
      haveWaist: Helper.hasParametersAccess(Param.P9),
      haveMarketplace: Helper.hasParametersAccess(Param.P18),
      haveProductsCompound: Helper.hasParametersAccess(Param.P30),
      haveUnitMeasurement: Helper.hasParametersAccess(Param.P31),
    },
  }),
  computed: {
    isContents() {
      const modules = Session.getSession().auth.user.permissions.modules || []
      return modules.some(module => module.id === Modules.CONTENIDOS)
    },
    dashboardActions() {
      const actions = []
      if(!this.parameters.haveMarketplace) actions.push({ id: 'crudProducts', reference: 'crudProducts', route: 'ProductsStaffCrudProducts', tone: 'primary' })
      if(!this.parameters.haveMarketplace && this.isContents) actions.push({ id: 'crudProductsWeb', reference: 'crudProductsWeb', route: 'ProductsStaffCrudProductsWeb', tone: 'secondary' })
      if(this.parameters.haveMarketplace) actions.push({ id: 'crudProductsMarketplace', reference: 'crudProductsMarketplace', route: 'ProductsStaffCrudProductsMarketplace', tone: 'primary' })
      if(this.parameters.haveProductsCompound) actions.push({ id: 'crudProductsCompound', reference: 'crudProductsCompound', route: 'ProductsStaffCrudProductsCompound', tone: 'success' })
      actions.push({ id: 'crudCategories', reference: 'crudCategories', route: 'ProductsStaffCrudCategories', tone: 'secondary', group: 'Configuraciones' })
      if(this.parameters.haveLines) actions.push({ id: 'crudItems', reference: 'crudItems', route: 'ProductsStaffCrudLines', tone: 'warning', group: 'Configuraciones' })
      if(this.parameters.haveColors) actions.push({ id: 'crudColors', reference: 'crudColors', route: 'ProductsStaffCrudColors', tone: 'primary', group: 'Configuraciones' })
      if(this.parameters.haveWaist) actions.push({ id: 'crudWaist', reference: 'crudWaist', route: 'ProductsStaffCrudWaist', tone: 'secondary', group: 'Configuraciones' })
      if(!this.parameters.haveMarketplace && this.parameters.haveUnitMeasurement) actions.push({ id: 'crudUnitMeasurement', reference: 'crudUnitMeasurement', route: 'ProductsStaffCrudUnitMeasurement', tone: 'success', group: 'Configuraciones' })
      if(this.parameters.haveMarketplace) actions.push({ id: 'summaryContactSold', reference: 'summaryContactSold', route: 'ProductsStaffSummaryContactSold', tone: 'warning' })
      if(!this.parameters.haveMarketplace) actions.push({ id: 'printLabels', reference: 'printLabels', route: 'ProductsStaffPrintLabels', tone: 'secondary' })
      actions.push({ id: 'priceAudit', reference: 'priceAudit', route: 'ProductsStaffPriceAudit', tone: 'warning' })
      return actions
    },
  },
  methods: {
    filterWidgets(widget) {
      const reference = widget.reference
      if(['pie_origen_marketplace_interested', 'list_marketplace_message_send_interested'].includes(reference)) return this.parameters.haveMarketplace
      if(['list_products_with_stock_minimum', 'list_products_without_stock'].includes(reference)) return !this.parameters.haveMarketplace
      if(reference === 'list_sublines') return this.parameters.haveLines
      return true
    },
  },
}
</script>
